const commonActionTypes = {
  SET_CONTEXT: 'SET_CONTEXT',

  FETCH_DROPDOWNS: 'FETCH_DROPDOWNS',
  FETCH_DROPDOWNS_SUCCESS: 'FETCH_DROPDOWNS_SUCCESS',
  FETCH_DROPDOWNS_FAIL: 'FETCH_DROPDOWNS_FAIL',

  FETCH_FIREBASE_CONFIG: 'FETCH_FIREBASE_CONFIG',
  FETCH_FIREBASE_CONFIG_SUCCESS: 'FETCH_FIREBASE_CONFIG_SUCCESS',
  FETCH_FIREBASE_CONFIG_FAIL: 'FETCH_FIREBASE_CONFIG_FAIL',
};

export default commonActionTypes;
